<template>
    <b-card title="Filters" class="text-center" title-tag="h5">
        <b-card-body>
            <b-row class="mt-12">
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-due_from"
                        label="Due From"
                        label-for="input-due_from"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            id="input-due_from"
                            :max="assetServiceFilter.due_to"
                            v-model="assetServiceFilter.due_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-due_to"
                        label="Due To"
                        label-for="input-due_to"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :min="assetServiceFilter.due_from"
                            id="input-due_to"
                            v-model="assetServiceFilter.due_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-completion-date_from"
                        label="Complete From"
                        label-for="input-completion-date_from"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :max="assetServiceFilter.completion_date_to"
                            id="input-completion-date_from"
                            v-model="assetServiceFilter.completion_date_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-completion-date_to"
                        label="Complete To"
                        label-for="completion-date_to"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            :min="assetServiceFilter.completion_date_from"
                            id="completion-date_to"
                            v-model="assetServiceFilter.completion_date_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-status"
                        label="Activity Status"
                        label-for="input-status"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-status"
                            v-model="assetServiceFilter.status"
                            value-field="id"
                            text-field="name"
                            :options="status"
                        >
                            <template #first>
                                <b-form-select-option :value="null">
                                    --Select Status--
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assets-servicequeryfilters',
    mixins: [permissionsMixins],

    props: [
        'value',
    ],
    data() {
        return {
            status: [
                { id: 1, name: 'Completed' },
                { id: 2, name: 'Processing' },
                { id: 3, name: 'Pending' },
                // Add more options as needed
            ],
            // Other data properties
        }
    },
    computed: {
      
        assetServiceFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
            // setter
            set(val) {
                if (!val.checkoff_type_id) {
                    val.checkoff_completed = null
                }
                val.completion_date_from
                this.$emit('input', val)
            },
        },
        completedValues() {
            return [
                { value: null, text: 'Any' },
                { value: 1, text: 'Yes' },
                { value: 2, text: 'No' },
            ]
        },
        changedValues() {
            return [
                { value: null, text: 'All' },
                { value: 1, text: 'Changed' },
                { value: 2, text: 'Unchanged' },
            ]
        },
    },
    // created() {
    //     this.$store.dispatch('roles/fetchAll')
    // },
    mounted() {
        // this.$store.dispatch('orders/fetchDrivers')
        //init remote filters
    },
    methods: {},
}
</script>
